import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookFluidsRefilTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          fluids_refils: {},
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          aircraft_logbook_flight_id: '',
          fluid_refill_id: '',
          qty: '',
          unity: '',
          fluid_refill_option: null,
          type: 'select',
          flight_legs_list: [],
          approvals: [],
        };
        this.add = this.add.bind(this);
        this.delete = this.delete.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.fluids_refils !== 'undefined' && newProps.fluids_refils !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            fluids_refils: newProps.fluids_refils,
          });
        }

        if(typeof newProps.fluids_refills_list !== 'undefined' && newProps.fluids_refills_list !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            fluids_refills_list: newProps.fluids_refills_list,
          });
        }

        if(typeof newProps.flight_legs_list !== 'undefined' && newProps.flight_legs_list !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            flight_legs_list: newProps.flight_legs_list,
          });
        }

        if(typeof newProps.approvals[6] !== 'undefined' && newProps.approvals[6] !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals: newProps.approvals[6],
          });
        }
      }
    
      // Fetch salvando a edição
      add(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          aircraft_logbook_flight_id: this.state.aircraft_logbook_flight_id,
          fluid_refill_id: this.state.fluid_refill_id,
          qty: this.state.qty,
          unity: this.state.unity,
          type: this.state.type,
          fluid_refill_option: this.state.fluid_refill_option,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/fluidos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({
              aircraft_logbook_flight_id: '',
              fluid_refill_id: '',
              qty: '',
              unity: '',
            });
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      delete (id) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/fluido/'+id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      changeInput(type) {
        this.setState({
          type: type,
        });
      }
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />
        <h3 className="page-title pull-left">Fluids Refill</h3>
        <div className="clearfix"></div>
        <hr/>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>Flight Leg:</label>
                <br/>
                <Select
                  className="form-group"
                  name="aircraft_logbook_flight_id"
                  value={this.state.aircraft_logbook_flight_id}
                  searchable={true}
                  placeholder={'Select leg'}
                  onChange={this.handleSelectChange.bind(this, 'aircraft_logbook_flight_id')}
                  options={this.state.flight_legs_list}
                  required
                />
              </div>
            </div>
            {this.state.type === 'input' ?  
              <div className="col-md-3">
                <div className="form-group">
                  <label>New system option: <button type="button" onClick={() => {self.changeInput('select')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-refresh"></i></button></label>
                  <input type="text" name="fluid_refill_option" className="form-control" placeholder="" value={this.state.fluid_refill_option} onChange={this.handleChange.bind(this, 'fluid_refill_option')} required/>
                </div>
              </div>
            : 
            <div className="col-md-3">
              <div className="form-group">
                <label>System: <button type="button" onClick={() => {self.changeInput('input')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-plus"></i></button></label>
                <Select
                  className="form-group"
                  name="fluid_refill_id"
                  value={this.state.fluid_refill_id}
                  searchable={true}
                  placeholder={'System options'}
                  onChange={this.handleSelectChange.bind(this, 'fluid_refill_id')}
                  options={this.state.fluids_refills_list}
                  required
                />
              </div>
            </div>            
            }
            <div className="col-md-3">
              <div className="form-group">
                <label>Qty:</label>
                <br/>
                <input type="text" className="form-control" value={this.state.qty} name="qty" onChange={this.handleChange.bind(this, 'qty')} placeholder="Quantidade abastecida" required />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Unity:</label>
                <br/>
                <Select
                  className="form-group"
                  name="unity"
                  value={this.state.unity}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'unity')}
                  options={[
                    {value: "liters", label: "Liters"},
                    {value: "milliliters", label: "Milliliters"},
                    {value: "gallons", label: "Gallons"},
                  ]}
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <button type="submit" className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Cadastrar</button>
              </div>
            </div>
          </div>
        </form>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Fluids Refill</caption>
            <thead>
              <tr className="text-center">
                <th>Flight Leg</th>
                <th>System</th>
                <th>Qty</th>
                <th>Unity</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody id="fluids_refils">
              {Object.keys(self.state.fluids_refils).map(function(k) {
                var fluid_refil = self.state.fluids_refils[k];
                return(
                  <tr className="text-center" key={fluid_refil.id}>
                    <td>{fluid_refil.leg}</td>
                    <td>{fluid_refil.fluid_refill.name}</td>
                    <td>{fluid_refil.qty}</td>
                    <td>{fluid_refil.unity_str}</td>
                    <td>
                      <div>
                        <button onClick={() => {self.delete(fluid_refil.id)}} className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Approval</caption>
            <thead>
              <tr className="text-center">
                <th>User</th>
                <th>Status</th>
                <th>Approval Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody id="fluids_refil_approvals">
            {self.state.approvals.map(function(k) {
                var approval = k;
                return(
                  <tr className="text-center" key={approval.id}>
                    {
                      (typeof approval.user_id !== 'undefined' && approval.user_id !== null) ?
                      <td>{approval.user_name}</td>
                      :
                      <td></td>
                    }
                    <td>{approval.status_str}</td>
                    <td>{approval.approval_date_str}</td>
                    {
                      (approval.status === 1) ?
                        <td>
                          <div>
                            <button className="btn btn-success btn-sm" disabled><i className="fa fa-check"></i></button>
                          </div>
                        </td>
                      :
                      <td>
                        <div>
                          <button onClick={() => {self.props.approve(approval.id, approval.type)}} className="btn btn-success btn-sm"><i className="fa fa-check"></i></button>
                        </div>
                      </td>
                    }
                  </tr>
                );
              })
            }
            </tbody>
          </table>
        </div>
    </div>
    );
  }
}

export default AircraftLogbookFluidsRefilTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookFluidsRefilTab.js